import { createApplicationMenu as e } from "../../utils/applicationMenu/applicationMenu.js";
import { createContext as t } from "react";
//#region src/components/ApplicationMenu/ApplicationMenuContext.ts
var n = t(e());
//#endregion
export { n as ApplicationMenuContext };
